import React from 'react';
import VALoanCalculator from '../VALoanCalculator/VALoanCalculator.js';

var FHACalculatorBlock = {
  Component: function Component() {
    return /*#__PURE__*/React.createElement(VALoanCalculator, {
      isFHAEnabled: true
    });
  },
  metadata: {
    version: '1.0',
    name: 'constellation/fha-calculator',
    title: 'FHA Calculator',
    description: 'Estimate your monthly payment, taxes and down payment needed to qualify for an FHA mortgage loan.',
    icon: 'chart-line',
    category: 'Calculators',
    keywords: ['mortgages', 'calculators', 'fha', 'first', 'time', 'homebuyers'],
    supports: {
      customClassName: false,
      html: false
    }
  }
};
var FHACalculatorBlock$1 = FHACalculatorBlock;

export { FHACalculatorBlock$1 as default };
